import { render, staticRenderFns } from "./shortCutBarDialog.vue?vue&type=template&id=36d4b34d&scoped=true&"
import script from "./shortCutBarDialog.vue?vue&type=script&lang=js&"
export * from "./shortCutBarDialog.vue?vue&type=script&lang=js&"
import style0 from "./shortCutBarDialog.vue?vue&type=style&index=0&id=36d4b34d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d4b34d",
  null
  
)

export default component.exports